import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const tabs = [
  { path: '/',         label: 'Home',     emoji: '🏠' },
  { path: '/book',     label: 'Book',     emoji: '✂️' },
  { path: '/messages', label: 'Messages', emoji: '💬' },
];

export default function Nav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav style={{
      position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
      width: '100%', maxWidth: 480,
      background: 'var(--card)', borderTop: '1px solid var(--border)',
      display: 'flex', height: 72, paddingBottom: 10,
    }}>
      {tabs.map(t => {
        const active = location.pathname === t.path;
        return (
          <button
            key={t.path}
            onClick={() => navigate(t.path)}
            style={{
              flex: 1, display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'center', gap: 3,
              background: 'none', border: 'none', cursor: 'pointer',
            }}
          >
            <span style={{ fontSize: 22, opacity: active ? 1 : 0.4 }}>{t.emoji}</span>
            <span style={{
              fontSize: 11, fontWeight: 700,
              color: active ? 'var(--accent)' : 'var(--subtext)',
            }}>
              {t.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
